<template>
    <div>
        <TerrenoJuegoComponent/>

        <div class="container-butacas-wrapper scroll-smooth mb-2" v-if="!loading" ref="butacasWrapper">
            <div :class="'container-butacas animated fadeInLeft text-align-' + print_align">
                <span v-for="(fila, index_fila) in filas" :key="index_fila">
                    <span class="fila">{{ fila.alias }}</span>
                    <div class="ml-3">
                        <AsientoComponent 
                            v-for="(asiento, index) in fila.asientos" 
                            :asiento="asiento" 
                            :fila="String(fila.alias)" 
                            :front="true" 
                            :key="index+'_2'" 
                            @toggle="() => toggleSeleccion(asiento)"
                        />
                    </div>
                </span>
            </div>
        </div>
        <template v-else>
            <LoaderComponent/>
        </template>
    </div>
</template>

<script>
    import TerrenoJuegoComponent from './TerrenoJuegoComponent.vue';
    import AsientoComponent from "@/components/backend/stepper/components/AsientoComponent";

    export default {
        props: {
            loading: {
                type: Boolean,
                required: true
            },
            print_align: {
                type: String,
                required: true
            },
            filas: {
                type: Object,
                required: true
            }
        },
        methods: {
            toggleSeleccion(asiento) {
                this.$emit('asientoSeleccionado', asiento);
            }
        },
        components: {
            TerrenoJuegoComponent, AsientoComponent
        }
    }
</script>